import { useEffect, useRef, useState, type ReactNode } from "react";

export function DeferredHomepageSection({
  children,
  rootMargin = "800px 0px",
}: {
  children: ReactNode;
  rootMargin?: string;
}) {
  const sentinelRef = useRef<HTMLDivElement | null>(null);
  const [ready, setReady] = useState(
    () => typeof window === "undefined" || typeof window.IntersectionObserver !== "function",
  );

  useEffect(() => {
    if (ready) return;
    const node = sentinelRef.current;
    if (!node) {
      setReady(true);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setReady(true);
          observer.disconnect();
        }
      },
      { rootMargin },
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [ready, rootMargin]);

  if (ready) return <>{children}</>;

  return (
    <div
      ref={sentinelRef}
      className="hp-deferred-sentinel"
      aria-hidden="true"
      data-deferred-homepage-section
    />
  );
}
